module.exports = __webpack_public_path__ + "static/media/MainLogo.f6270bb8.jpeg";